export const ShopifyActions = {
  redirectUrl: '[shopify-retailers] redirect url',
  finished: '[shopify-retailers] finished',
  loading: '[shopify-retailers] loading',
  customerId: '[shopify-customer] customer id',
};

const initialState = {
  loading: {
    redirectUrl: false,
  },
  redirectUrl: null,
  shopifyCustomerAccountId: null,
};

const shopify = (state = initialState, action) => {
  switch (action.type) {
    case ShopifyActions.redirectUrl:
      return {
        ...state,
        ...action.payload,
        loading: {
          redirectUrl: false,
        },
      };
    case ShopifyActions.finished:
      return {
        ...state,
        redirectUrl: null,
        loading: {
          ...state.loading,
          redirectUrl: false,
        },
      };
    case ShopifyActions.loading:
      return {
        ...state,
        loading: {
          ...state.loading,
          ...action.payload,
        },
      };
    case ShopifyActions.customerId:
      const { shopifyCustomerAccountId } = action.payload;
      return {
        ...state,
        shopifyCustomerAccountId,
      };
    default:
      return state;
  }
};

export default shopify;
